import type { GetTransferQueueStatsParams } from '#services/api/transfer-queue.ts';
import type { loader as homeLoader } from '../Home.data.ts';

import { endOfDay, format, startOfDay } from 'date-fns';
import { useLoaderData } from 'react-router';

import { apiTimezone, FORMATS } from '#utils/dates.ts';
import { toProviderIdParam } from '#utils/provider-filter.ts';

export function useTransferQueue() {
  const homeData = useLoaderData<ReturnType<typeof homeLoader>>();

  function getRequestParams() {
    return {
      timezone: apiTimezone,
      minEnteredAt: format(startOfDay(homeData.from), FORMATS.MYSQL_DATETIME),
      maxEnteredAt: format(endOfDay(homeData.to), FORMATS.MYSQL_DATETIME),
      appointmentId: homeData.appointmentId,
      providerId: toProviderIdParam(homeData.providerIds),
      appointmentStatusId: homeData.appointmentStatusIds,
      appointmentTypeId: homeData.appointmentTypeIds,
      addressId: homeData.addressIds,
      isCurrentlyQueued:
        homeData.queueState === 'all' ? undefined : homeData.queueState === 'current' ? 1 : 0,
      patientDisconnected:
        homeData.patientDisconnected === 'all'
          ? undefined
          : homeData.patientDisconnected === 'yes'
            ? 1
            : 0,
    } as const satisfies GetTransferQueueStatsParams;
  }

  return { getRequestParams, homeData };
}
